// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyBt04spXJrD5H1K_1EJzocZ-PdCGoN8Re8",
    authDomain: "server-touchbud-next-play.firebaseapp.com",
    databaseURL: "https://server-touchbud-next-play.firebaseio.com",
    projectId: "server-touchbud-next-play",
    storageBucket: "server-touchbud-next-play.appspot.com",
    messagingSenderId: "959126678499",
    appId: "1:959126678499:web:c78dbd9368f6c79a478ed6",
    measurementId: "G-VR1G4QVGDS"
  }
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
